<template>
 <follow-up :data="followup" :referal="referal" v-if="followUpViewFlag && referalFlag"/>
    <div v-else>
      <div class="sa-mob-header">
        <button class="sa-btn-back" @click="$parent.selectTestPackFlag = false">
          <i class="icon-arrow-left"></i>
        </button>
        <h5 class="sa-card-tit sa-h-sm-up">Selected test</h5>
      </div>
      <div class="sa-mob-cont">
        <div class="sa-row">
          <div class="sa-col-xs12 sa-col-sm12 sa-col-md12 sa-col-lg3">
            <div v-if="tests && tests.length" class="sa-card">
              <strong >Selected Test</strong>
              <ul class="sa-unorder-list">
                <li v-for="(test, index) in tests" :key="index">{{test.tst_nm}}</li>
              </ul>
            </div>
            <div v-if="packages && packages.length" class="sa-card">
              <strong class="sa-d-block sa-mb10">Selected Package</strong>
              <ul class="sa-unorder-list">
                <li v-for="(packages, index) in packages" :key="index">{{packages.pkg_nm}}</li>
              </ul>
              <!-- <span>{{packages.pkg_nm}}</span> -->
            </div>
          </div> 
        </div>
        <h6 v-if="patDetails && patDetails.stid == 'ST1' && !followUpFlag && followupTime">Select video consultation follow up</h6>
          <div v-if="patDetails && patDetails.stid == 'ST1' && !followUpFlag && followupTime" class="sa-row sa-mt20">
          <div class="sa-form-group sa-col-xs12 sa-col-sm4 sa-col-md6 sa-col-lg4">
            <div class="sa-card sa-card-noshadow sa-card-border sa-follow-icon">
                <div @click="followUp" v-if="!followupcheck">
                    Please Select Slot <i class="icon-picker"></i>
                </div>
                <template>
                  <span id="i" v-if="followupcheck">
                  {{followupcheck.date}} {{followupcheck.strt_tym}} To {{followupcheck.end_tym}}
                  <button @click="followUpCancel" class="sa-btn-transparent sa-red-text">Remove</button>
                  </span>
                </template>
            </div>
           
          </div>
        </div>
          <!-- <file-upload/> -->
      </div>
      <div class="sa-text-right sa-ftr-btn">
        <button @click="$parent.selectTestPack()" :disabled="followupbutton" class="sa-btn sa-btn-large sa-btn-primary sa-btn-block-xs">Continue</button>
    </div> 
    </div>
</template>
<script>
 import { pro_url } from "../../../../../config/endpoints"
 import FileUploadVue from "../../../common/FileUploadMultiple.vue"
import FollowUpDateVue from '../FollowUpDate.vue'
import moment from 'moment'
export default {
   components: {
    //props: ['packages', 'tests'],
    "file-upload": FileUploadVue,
    "follow-up": FollowUpDateVue
  },
    data() {
        return{
          referal:true,
          tests: [],
          packages: [],
          referalFlag:false,
          followUpViewFlag:false,
          followUpFlag:false,
          followupcheck:null,
          patDetails:null,
          followupTime:false,
          followupbutton: false
        }
    },
    mounted(){
      let _self = this
     // console.log(this.$parent);
     console.log(this.$parent.selectTest,'sss');
      this.packages = this.$parent.selectPakage
      this.tests = this.$parent.selectTest
      this.init()
      //this.getReferralData()
    },
      methods: {
        init(){
          this.patDetails = JSON.parse(this.$localStorage.get("apntDet"))
          this.followupcheck = JSON.parse(this.$localStorage.get("followUp"))
          if(this.patDetails && this.patDetails.followUp){
            this.followUpFlag = true
            this.followUpViewFlag = true
            this.followupbutton = true
          }else {
            this.followUpFlag = false
            this.followUpViewFlag = false
          }
          if(this.patDetails && this.patDetails.date){
            let dt = moment(this.patDetails.date).add(14, 'days').format("YYYY-MM-DD");
              let cur_dt = moment().format("YYYY-MM-DD")
              if(moment(cur_dt).isSameOrBefore(moment(dt))){
                console.log(dt);
                  this.followupTime = true
                }else {
                    this.followupTime = false
              }
          }
          
        },
           followUp(){
        if(!this.followUpFlag){
          this.followUpFlag =true
          this.followUpViewFlag =true
          this.referalFlag =true
        }
        else{
          this.followUpFlag =false
          this.followUpViewFlag =false
          this.referalFlag =true
        }
      },
        followUpCancel(){
      let _self = this;
      _self.loader = true;
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/followUp/removeSlot`,
          body: {
            apnt_id: _self.$route.params.appid,
          },
        })
        .then((response) => {
          _self.loader = false;
          if (response && response.status === 1000) {
            //_self.diagnosisDetails();
            _self.$localStorage.remove('followUp')
            _self.followupcheck = null
             _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: response.message,
              class: "sa-a-success"
            });
          }else {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: response.message,
              class: "sa-a-danger"
            });
          }
        })
    },
        getReferralData () {
        let _self = this
        _self.patDetails = JSON.parse(_self.$localStorage.get('patDetails'))    
        _self.$store.dispatch('httpPost', {
          uri: `${pro_url}/refer/getTreatmentReferal`,
          body:{
            "apnt_id": _self.patDetails.apnt_id
          }
        }).then(response => {
          if (response && response.status === 1000 && response.data) {
            if(response.data.test_packages) {
              let test_packages = response.data.test_packages
              if (test_packages.tests) {
               // _self.tests = test_packages.tests.name
              }
              if (test_packages.package) {
                //_self.packages = test_packages.package.name
              }
            }
          }
        })
      },
      },
      computed: {
      },
}
</script>